var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 128 128",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M95.331 27.471H81.083v-4.516a5.712 5.712 0 0 0-5.7-5.7H52.621a5.712 5.712 0 0 0-5.705 5.7v4.516H32.668a5.425 5.425 0 0 0-5.419 5.419v5.857a5.426 5.426 0 0 0 5.419 5.419h.071v59.041a7.551 7.551 0 0 0 7.542 7.543h47.437a7.551 7.551 0 0 0 7.542-7.543V44.166h.071a5.425 5.425 0 0 0 5.418-5.419V32.89a5.424 5.424 0 0 0-5.418-5.419zm-44.915-4.516a2.207 2.207 0 0 1 2.205-2.2h22.757a2.207 2.207 0 0 1 2.2 2.2v4.516H50.416zm41.344 80.252a4.047 4.047 0 0 1-4.042 4.043H40.281a4.047 4.047 0 0 1-4.042-4.043V44.166H91.76zm5.489-64.46a1.92 1.92 0 0 1-1.918 1.919H32.668a1.921 1.921 0 0 1-1.919-1.919V32.89a1.921 1.921 0 0 1 1.919-1.919h62.663a1.92 1.92 0 0 1 1.918 1.919z",
    fill: "#656565",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64 95.541a1.749 1.749 0 0 0 1.75-1.75V57.625a1.75 1.75 0 1 0-3.5 0v36.166a1.75 1.75 0 0 0 1.75 1.75zM79.333 95.541a1.75 1.75 0 0 0 1.75-1.75V57.625a1.75 1.75 0 0 0-3.5 0v36.166a1.75 1.75 0 0 0 1.75 1.75zM48.666 95.541a1.75 1.75 0 0 0 1.75-1.75V57.625a1.75 1.75 0 0 0-3.5 0v36.166a1.75 1.75 0 0 0 1.75 1.75z",
    fill: "#656565",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete2);
export default __webpack_public_path__ + "static/media/delete2.53b2945eb0ccfdadba37752262daf194.svg";
export { ForwardRef as ReactComponent };